import { HttpContextToken } from '@angular/common/http';

/** Keeps a relative `/api/...` request on the website origin instead of
 * routing it through the general API gateway. Used for Nginx-owned adapters
 * such as the public PLS tracking proxy. */
export const USE_SAME_ORIGIN_API = new HttpContextToken<boolean>(() => false);
